module.exports = __webpack_public_path__ + "static/media/shopping-list.0b9f50bc.svg";